import Inputmask from "inputmask";
document.addEventListener('DOMContentLoaded', () => {

    let inputTelList = document.querySelectorAll('input[type=tel]');
    inputTelList && inputTelList.forEach(function (el) {
        // let inputTel = new Inputmask({
        Inputmask({
            showMaskOnHover: false,
            showMaskOnFocus: true,
        }).mask(el);
    });
    let inputMakList = document.querySelectorAll('.input-mask');
    inputMakList && inputMakList.forEach(function (el) {
        Inputmask({
            showMaskOnHover: false,
            showMaskOnFocus: true,
        }).mask(el);
    });

});